import Header from '../pages/home/Header';
import Footer from '../pages/home/Footer';

const AuthLayout = ({ children }) => (
  <>
    <Header />
    <div className='bg-gray-100 h-[calc(100vh-132px)] p-8 max-md:p-2 overflow-y-scroll '>
      {children}
    </div>
    <Footer />
  </>
);
export default AuthLayout;
//Sample
